const Globals = require('./globals');

class Config {

  static getPrincipleUrl() {
    return `https://principle-api.${Globals.getXbsEnvironment()}xbs.com`;
  };

  static getProxyUrl() {
    return `https://proxy.${Globals.getXbsEnvironment()}xbs.com`;
  };
}

module.exports = Config;